import { render, staticRenderFns } from "./visitDetail.vue?vue&type=template&id=10b20213&scoped=true"
import script from "./visitDetail.vue?vue&type=script&lang=js"
export * from "./visitDetail.vue?vue&type=script&lang=js"
import style0 from "./visitDetail.vue?vue&type=style&index=0&id=10b20213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b20213",
  null
  
)

export default component.exports